import { render } from "./fh.vue?vue&type=template&id=68b2452a&scoped=true&ts=true"
import script from "./fh.vue?vue&type=script&lang=ts"
export * from "./fh.vue?vue&type=script&lang=ts"

import "./fh.vue?vue&type=style&index=0&id=68b2452a&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b2452a"]])

export default __exports__